
        import * as module0 from './controllers/tabs_controller.js'
        const modules = {
            "./controllers/tabs_controller.js": module0,
        };
        export default modules;
      